import { SubmoduleFilterMap } from '@stores/Modules/types/modules';

export interface DashboardSubmoduleFilters {
  filterOptions: string[];
  filterMap: SubmoduleFilterMap;
}

export interface DashboardSelectorSubmoduleItem {
  submoduleId: string;
  name: string;
  moduleId?: string;
  membershipId?: string | null;
  submoduleType?: string;
  defaultFilter?: string | null;
  nativeFilterId?: string | null;
  hasFullAccess?: boolean;
  accessType?: string | null;
  scopeType?: string | null;
  editable?: boolean;
  appAccess?: AppAccess;
}

export interface DashboardSelectorModuleItem {
  name: string;
  id: string;
  submodules: DashboardSelectorSubmoduleItem[];
}

export type DashboardSelectorListItem =
  | DashboardSelectorModuleItem
  | DashboardSelectorSubmoduleItem;

export type AppAccessFilter = {
  rowId: string;
  submoduleFilterId: string;
  filterValue: string;
};

export enum AppAccessType {
  DEMO = 'DEMO',
  CUSTOM = 'CUSTOM',
  FULL_ACCESS = 'FULL_ACCESS',
}

export type AppAccess = {
  type: AppAccessType;
  filters?: AppAccessFilter[];
};

export const DEMO_ACCESS_TEMPLATE_TYPE = 'DEMO';
